import { NgModule } from '@angular/core';
import { provideConfig } from  '../../../core/config/config-providers';

@NgModule({
  providers: [
    provideConfig({
      api: {
        endpoints: {
            hptransaction: {
               path: 'transaction/${transactionId}',
               auth: false
            },
            hpreceipt: {
              path: 'transaction/${transactionId}/receipt',
              auth: false
            },

            paymentFrameFromLink: {
              path: 'paymentFrame/${frameId}',
              auth: false
            },
            hostedPaymentFrame: {
              path: 'paymentFrame/${frameId}',
              auth: false
            },
            hostedPaymentSale: {
              path: 'transaction/sale',
              auth: false
            },
            taxRateStateLookup: {
              path: 'tax-rates/state-lookup',
              auth: false
            },
          },

        }
      })
  ],
})

export class ConfigModule { }

